<template>
  <nav
    class="navbar is-fixed-top p-3"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img src="../assets/nfd-logo-black_3.png" />
      </a>
      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="daddys-nav">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="daddys-nav" class="navbar-menu is-right">
      <div class="navbar-start">
      </div>
      <div class="navbar-end">
        <!-- <a class="navbar-item" href="/#home"> HOME </a> -->

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" href="javascript:void" v-bind:class="{ 'highlight': ['/nfd-academy/nft-101', '/nfd-academy/glossary', '/nfd-academy/web3-workshops', '/nfd-academy/scholarship', '/nfd-academy/philanthropic', '/nfd-academy/security-and-safety', '/nfd-academy/mental-health'].includes(this.$route.path) }">
            🏫 NFD Academy
          </a>
          <div class="navbar-dropdown is-boxed">
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['nft-101'].includes(this.$route.name) }" href="/nfd-academy/nft-101">NFT 101</a>
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['/nfd-academy/web3-workshops'].includes(this.$route.path) }" href="/nfd-academy/web3-workshops">Web3 Workshops</a>
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['glossary'].includes(this.$route.name) }" href="/nfd-academy/glossary">Glossary</a>
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['scholarship'].includes(this.$route.name) }" href="/nfd-academy/scholarship">Scholarship</a>
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['philanthropic'].includes(this.$route.name) }" href="/nfd-academy/philanthropic">Philanthropic</a>
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['security-and-safety'].includes(this.$route.name) }" href="/nfd-academy/security-and-safety">Security and Safety</a>
            <!-- <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['mental-health'].includes(this.$route.name) }" href="/nfd-academy/mental-health">Mental Health</a> -->
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" href="javascript:void" v-bind:class="{ 'highlight': ['/events/web3-workshops', '/events/meta-music-hall', '/events/twitter-spaces', '/events/community-spotlight', '/events/fathers-day-5k', '/events/past-events'].includes(this.$route.path) }">
            📅 Events
          </a>
          <div class="navbar-dropdown is-boxed">
             <a class="navbar-sub-item" href="https://www.cryptovoxels.com/parcels/6270" target="_blank"><strong>Visit our Metaverse!</strong></a>
             <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['/events/web3-workshops'].includes(this.$route.path) }" href="/events/web3-workshops">Web3 Workshops</a>
             <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['meta-music-hall'].includes(this.$route.name) }" href="/events/meta-music-hall">Meta Music Hall</a>
             <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['twitter-spaces'].includes(this.$route.name) }" href="/events/twitter-spaces">Twitter Spaces</a>
             <!-- <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['community-spotlight'].includes(this.$route.name) }" href="/events/community-spotlight">Community Spotlight</a> -->
             <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['fathers-day-5k'].includes(this.$route.name) }" href="/events/fathers-day-5k">Fathers Day 5k Plus</a>
             <!-- <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['past-events'].includes(this.$route.name) }" href="/events/past-events">Past Events</a> -->
          </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" href="javascript:void">
            🌐 Token
          </a>
          <div class="navbar-dropdown is-boxed" v-bind:class="{ 'highlight': ['/token/mint', '/token/roadmap', '/token/faq', '/token/merch'].includes(this.$route.path) }">
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['mint'].includes(this.$route.name) }" href="/token/mint">Mint</a>
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['roadmap'].includes(this.$route.name) }" href="/token/roadmap">Roadmap</a>
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['faq'].includes(this.$route.name) }" href="/token/faq">FAQ</a>
            <!-- <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['merch'].includes(this.$route.name) }" href="/token/merch">Merch Store</a> -->
          </div>
        </div>

         <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" href="javascript:void" v-bind:class="{ 'highlight': ['/utility'].includes(this.$route.path) }">
            🧰 Utility
          </a>
          <div class="navbar-dropdown is-boxed">
            <a class="navbar-sub-item" href="/utility">Ask A Question!</a>
            <a class="navbar-sub-item" href="/utility">NFD Academy (Advanced)</a>
            <a class="navbar-sub-item" href="/utility">Web 3 Workshops</a>
            <a class="navbar-sub-item" href="/utility">Newsletter</a>
            <a class="navbar-sub-item" href="/utility">Skinned Games</a>
            <a class="navbar-sub-item" href="/utility">Marketplace</a>
            <a class="navbar-sub-item" href="/utility">Exclusive Merch</a>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" href="javascript:void" v-bind:class="{ 'highlight': ['/team/about', '/team/our-y', '/team/socials', '/team/portfolio', '/team/partners', '/team/contact'].includes(this.$route.path) }">
            🕺 Team
          </a>
          <div class="navbar-dropdown is-boxed is-right">
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['about'].includes(this.$route.name) }" href="/team/about">About Us</a>
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['our-y'].includes(this.$route.name) }" href="/team/our-y">Our Y</a>
            <!-- <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['socials'].includes(this.$route.name) }" href="/team/socials">Socials</a> -->
            <!-- <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['portfolio'].includes(this.$route.name) }" href="/team/portfolio">NFT Portfolio</a> -->
            <!-- <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['partners'].includes(this.$route.name) }" href="/team/partners">Partners</a> -->
            <a class="navbar-sub-item" v-bind:class="{ 'highlight': ['contact'].includes(this.$route.name) }" href="/team/contact">Contact</a>
          </div>
        </div>


        <!-- <a class="navbar-item" href="/#faq">FAQ</a> -->
        <!-- <a class="navbar-item" href="/#roadmap">ROADMAP</a> -->
        <!-- <a class="navbar-item" href="/nft101">NFT 101</a> -->
        <!-- <a class="navbar-item" href="/about">OUR Y</a> -->
        <!-- <a class="navbar-item is-yellow" href="/#team">CONTACT</a> -->
        <!-- <a class="navbar-item button is-small is-white is-twitter" href="https://twitter.com/nfdaddys" target="_blank" >
          <span class="icon">
            <i class="fab fa-twitter fa-lg"></i>
          </span>
        </a> -->
        <!-- <a class="navbar-item button is-small is-white is-discord" href="https://discord.gg/4gQZYE9NC9" target="_blank" >
          <span class="icon">
            <i class="fab fa-discord fa-lg"></i>
          </span>
        </a> -->
        <!-- <a class="navbar-item navbar-item-mint" href="/mint">
          MINT YOUR DADDY
        </a> -->
      </div>
    </div>
    <!-- <a class="header-twitter button is-small is-white is-twitter" href="https://twitter.com/nfdaddys" target="_blank" >
      <span class="icon">
        <i class="fab fa-twitter fa-lg"></i>
      </span>
    </a> -->
    <!-- <a class="header-discord button is-small is-white is-discord" href="https://discord.gg/4gQZYE9NC9" target="_blank" >
      <span class="icon">
        <i class="fab fa-discord fa-lg"></i>
      </span>
    </a> -->
  </nav>
</template>
<script>
export default {
  name: "Header",
  mounted() {
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

      // Add a click event on each of them
      $navbarBurgers.forEach( el => {
        el.addEventListener('click', () => {

          // Get the target from the "data-target" attribute
          const target = el.dataset.target;
          const $target = document.getElementById(target);

          // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
          el.classList.toggle('is-active');
          $target.classList.toggle('is-active');

        });
      });
    }
  }
};
</script>
<style scoped>
.navbar {
box-shadow: 0px 1px 6px #000;
background: rgb(255,81,0);
background: linear-gradient(153deg, rgba(255,81,0,1) 1%, rgba(255,204,0,1) 17%, rgb(254, 254, 254) 51%);
}
.navbar-item {
  color: #000000;
  font-family: "Luckiest Guy", 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 24px;
}
.navbar-sub-item {
  color: #111;
  font-family: "Rubik", sans-serif;
  font-size: 19px;
  padding: 0 14px;
  line-height: 34px;
  white-space: nowrap;
}
.navbar-sub-item:hover {
  color: #ff6a00 !important;
}
.navbar-brand {
  font-size: 60px;
  flex-grow: 2;
}

.navbar-link {
  cursor: default;
}
.navbar-link.highlight {
  color: #485fc7;
}
.navbar-sub-item.highlight {
  color: #485fc7;
}

.navbar-start {
  margin-right: 0;
}

.navbar-burger {
  color: #000;
}

.navbar-item {
  flex-grow: 0;
}

.navbar-item-mint {
  background: #eeeeee;
  margin-left: 20px;
  color: #000000;
}
.navbar-dropdown {
  display: flex !important;
  flex-direction: column;
}
.navbar-item.button {
  margin-top: 11px;
  margin-left: 12px;
}

.header-discord {
  display: none;
}

.navbar-item.is-yellow:hover {
  color: #ffcc00 !important;
}
</style>

<style>

@media (max-width: 1023px) {

  #daddys-nav .navbar-item {
    color: #000 !important;
  }

    #daddys-nav .navbar-item:hover {
      color: #ffcc00 !important;
    }

    #daddys-nav .navbar-item-mint {
      color: #000 !important;
      margin-left: 0 !important;
      background: #eeeeee !important;
    }
      #daddys-nav .navbar-item-mint:hover {
        color: #ffcc00 !important;
      }

  #daddys-nav .navbar-item.button {
    display: none;
  }

  .header-discord.button.is-discord {
    display: block;
    position: absolute;
    top: 22px;
    right: 77px;
  }

}

</style>